import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from 'store/ducks';
import DomainSettingService from 'services/domainSetting.service';
import { IBatchRequestResponse } from 'models/Batch';
import { IDomainSetting } from 'models/DomainSetting';

const MANAGEMENT_PANEL_SETTING_ID = 'UsersAllowAccessManagementPanelScreen';

interface ManagementPanelRouteGuardProps {
  children: React.ReactNode;
}

/**
 * Guarda de rota para /painel-gestao.
 * Só renderiza o conteúdo se o usuário estiver na lista do domain setting
 * UsersAllowAccessManagementPanelScreen (enabled e value contendo o username).
 * Caso contrário, redireciona para /cotacoes-dashboard.
 */
export const ManagementPanelRouteGuard: React.FC<ManagementPanelRouteGuardProps> = ({ children }) => {
  const user = useSelector((state: RootState) => state.user);
  const [allowed, setAllowed] = useState<boolean | null>(null);
  const _domainSettingService = new DomainSettingService();

  useEffect(() => {
    if (!user?.username) {
      setAllowed(false);
      return;
    }
    
    _domainSettingService
      .get(undefined, undefined, undefined, {
        and: [
          { identifier: { eq: MANAGEMENT_PANEL_SETTING_ID } },
          { enabled: { eq: true } },
        ],
      })
      .then((result: IBatchRequestResponse<IDomainSetting> | undefined) => {
        if (result?.data && result?.data?.length > 0 && user?.username) {
          const value = result?.data?.[0]?.value;
          const splitedValue = value?.split(',');
          const userIsAllowed = splitedValue ? splitedValue.includes(user.username) : false;
          setAllowed(userIsAllowed);
        } else {
          setAllowed(false);
        }
      })
      .catch(() => setAllowed(false));
  }, [user?.username]);

  if (allowed === null) {
    return null;
  }
  
  if (!allowed) {
    return <Navigate to="/cotacoes-dashboard" replace />;
  }

  return <>{children}</>;
};
